import React, { useEffect, useState } from "react";
import { useShoppingCart } from "../../../context/CartContext.tsx/ShoppingCartContext";
import Modal from "./Modal";
import Popup from "reactjs-popup";
import 'reactjs-popup/dist/index.css';

interface CouponProp {
  cart_id: number | any;
  noOfCoupon: number;
}

const Coupon = ({ cart_id, noOfCoupon }: CouponProp) => {
  const {
    getCustomerCoupons,
    getCouponData,
    openPopup,
    modalOpenData,
    setError,
  } = useShoppingCart();
  const [modalOpen, setModalOpen] = useState(false);
  // console.log(modalOpen, 'modalOpen')

  const handleClickCoupon = () => {
    // console.log("one two three");
    openPopup("coupons");
  };


  const couponData: any = getCouponData;
  // const noOfCoupon: number = couponData?.data?.customer_coupons?.length;

  let noOfCoupons:number = 0;
  if (couponData?.data?.customer_coupons) {
    couponData.data.customer_coupons.forEach((item: { enable: boolean; }) => {
      if (item.enable == true) {
        noOfCoupons++;
      }
    });
  }


  return (
    <>
      {/* <div className="offer-section apply_offer_modal" onClick={() => getCustomerCoupons(props.cart_id)}> */}
      {/* getCustomerCoupons(cart_id) */}

      {/* <div className="offer-section apply_offer_modal" onClick={() => { setModalOpen(true); }}> */}

      {/* <Popup
        trigger={
          <button className="" style={{ width: "100%" }}>
            <div
              className="offer-section apply_offer_modal"
              //   onClick={() => {
              //     handleClickCoupon();
              //     setError();
              //   }}
            >
              <div className="flex items-center justify-between flex-1 button_content">
                <div className="offer__leftContent">
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20.03 8.87L18.51 7.35001C18.25 7.09 18.04 6.58001 18.04 6.22001V4.06C18.04 3.18 17.32 2.46 16.44 2.46H14.29C13.93 2.46 13.42 2.25 13.16 1.99L11.64 0.470005C11.02 -0.149995 10 -0.149995 9.38 0.470005L7.84 1.99C7.59 2.25 7.08 2.46 6.71 2.46H4.56C3.68 2.46 2.96 3.18 2.96 4.06V6.21C2.96 6.57 2.75 7.08 2.49 7.34L0.970005 8.86C0.350005 9.48 0.350005 10.5 0.970005 11.12L2.49 12.64C2.75 12.9 2.96 13.41 2.96 13.77V15.92C2.96 16.8 3.68 17.52 4.56 17.52H6.71C7.07 17.52 7.58 17.73 7.84 17.99L9.36 19.51C9.98 20.13 11 20.13 11.62 19.51L13.14 17.99C13.4 17.73 13.91 17.52 14.27 17.52H16.42C17.3 17.52 18.02 16.8 18.02 15.92V13.77C18.02 13.41 18.23 12.9 18.49 12.64L20.01 11.12C20.66 10.51 20.66 9.49 20.03 8.87ZM6.5 7C6.5 6.45 6.95 6 7.5 6C8.05 6 8.5 6.45 8.5 7C8.5 7.55 8.06 8 7.5 8C6.95 8 6.5 7.55 6.5 7ZM8.03 13.53C7.88 13.68 7.69 13.75 7.5 13.75C7.31 13.75 7.12001 13.68 6.97001 13.53C6.68001 13.24 6.68001 12.76 6.97001 12.47L12.97 6.47001C13.26 6.18001 13.74 6.18001 14.03 6.47001C14.32 6.76 14.32 7.24 14.03 7.53L8.03 13.53ZM13.5 14C12.94 14 12.49 13.55 12.49 13C12.49 12.45 12.94 12 13.49 12C14.04 12 14.49 12.45 14.49 13C14.49 13.55 14.05 14 13.5 14Z"
                      fill="#3D6AAE"
                    />
                  </svg>
                  <p className="coupen_text">Apply Offer</p>
                </div>
                <div className="arrow_svg">
                  <svg
                    width="7"
                    height="14"
                    viewBox="0 0 7 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1.43994 12.28L5.78661 7.9333C6.29994 7.41997 6.29994 6.57997 5.78661 6.06664L1.43994 1.71997"
                      stroke="#3D6AAE"
                      strokeWidth="1.5"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>

              {noOfCoupon && noOfCoupon > 0 && (
                <div className="awaitCouponWrappper flex items-center justify-between flex-1 button_content">
                  <span className="latestOffer">
                    Check out our latest offers
                  </span>
                  <span className="latestCoupons">
                    0{noOfCoupon} coupons awaiting
                  </span>
                </div>
              )}

              <p className="codeInput_error"></p>
            </div>
          </button>
        }
        closeOnDocumentClick
        modal
       
      >
       
        <Modal cart_id={cart_id} />
      </Popup> */}

      <div className="offer-section apply_offer_modal" onClick={() => { handleClickCoupon(); setError()}}>

                <div className="flex items-center justify-between flex-1 button_content">
                    <div className="offer__leftContent">

                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.03 8.87L18.51 7.35001C18.25 7.09 18.04 6.58001 18.04 6.22001V4.06C18.04 3.18 17.32 2.46 16.44 2.46H14.29C13.93 2.46 13.42 2.25 13.16 1.99L11.64 0.470005C11.02 -0.149995 10 -0.149995 9.38 0.470005L7.84 1.99C7.59 2.25 7.08 2.46 6.71 2.46H4.56C3.68 2.46 2.96 3.18 2.96 4.06V6.21C2.96 6.57 2.75 7.08 2.49 7.34L0.970005 8.86C0.350005 9.48 0.350005 10.5 0.970005 11.12L2.49 12.64C2.75 12.9 2.96 13.41 2.96 13.77V15.92C2.96 16.8 3.68 17.52 4.56 17.52H6.71C7.07 17.52 7.58 17.73 7.84 17.99L9.36 19.51C9.98 20.13 11 20.13 11.62 19.51L13.14 17.99C13.4 17.73 13.91 17.52 14.27 17.52H16.42C17.3 17.52 18.02 16.8 18.02 15.92V13.77C18.02 13.41 18.23 12.9 18.49 12.64L20.01 11.12C20.66 10.51 20.66 9.49 20.03 8.87ZM6.5 7C6.5 6.45 6.95 6 7.5 6C8.05 6 8.5 6.45 8.5 7C8.5 7.55 8.06 8 7.5 8C6.95 8 6.5 7.55 6.5 7ZM8.03 13.53C7.88 13.68 7.69 13.75 7.5 13.75C7.31 13.75 7.12001 13.68 6.97001 13.53C6.68001 13.24 6.68001 12.76 6.97001 12.47L12.97 6.47001C13.26 6.18001 13.74 6.18001 14.03 6.47001C14.32 6.76 14.32 7.24 14.03 7.53L8.03 13.53ZM13.5 14C12.94 14 12.49 13.55 12.49 13C12.49 12.45 12.94 12 13.49 12C14.04 12 14.49 12.45 14.49 13C14.49 13.55 14.05 14 13.5 14Z" fill="#3D6AAE" />
                        </svg>
                        <p className="coupen_text">Apply Offer</p>
                    </div>
                    <div className="arrow_svg">
                        <svg width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.43994 12.28L5.78661 7.9333C6.29994 7.41997 6.29994 6.57997 5.78661 6.06664L1.43994 1.71997" stroke="#3D6AAE" strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>


                    </div>
                </div>

                {noOfCoupons && noOfCoupons > 0 ? (
                  <>
                    <div className='awaitCouponWrappper flex items-center justify-between flex-1 button_content'>
                        <span className='latestOffer'>Check out our latest offers</span>
                        <span className='latestCoupons'>{noOfCoupons} coupons awaiting</span>
                    </div>
                    </>
                ) : <div className='awaitCouponWrappper flex items-center justify-between flex-1 button_content'>
                <span className='latestOffer'>Check out our latest offers</span>
                <span className='latestCoupons'>coupons awaiting</span>
            </div>
                }




                <p className="codeInput_error"></p>


            </div>
      {/* {modalOpen && <Modal setOpenModal={setModalOpen} cart_id={cart_id} />} */}

      {modalOpenData && modalOpenData.isPopup == true && modalOpenData.popupId === 'coupons' && <Modal setOpenModal={setModalOpen} cart_id={cart_id} />}
    </>
  );
};

export default Coupon;
